import { IImportModel } from '../importer/model';

export const ancillaryGroundServicesImportDomainSelector = (state: any): IImportModel =>
  state.ancillaryGroundServicesImport as IImportModel;
